//FilterInputControlView.js


import BaseControlView from 'BaseControlView.js';
import template from 'report/control-filter-input.ejs';
import eventBus         from 'EventBus.js';
//=====================================================================
//
// An instance of this view represents a filter input control.
//
// Rene Lopez, September 2016
//
//=====================================================================
class FilterInputControlView extends BaseControlView  {

        initialize( opts ) {
            super.initialize( opts );

            this.template = template;

            this.tagName = 'div';
            this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);
            
            return this;
        }
    
        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'FilterInputControlView';
        }
}

export default FilterInputControlView;
